<template>
    <v-dialog
    v-model="show"
    persistent
    class="def-font"
    width="480">
   
    <v-card>
        <v-toolbar  dense  >
            <v-icon left >mdi-cog</v-icon><span class="va-underline">{{state=='new'?'New':'Modify'}} Variant</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4">
              <strong>Properties</strong>
              <v-divider class="mb-6"/>
                  <div v-for="(prop,p) in sku.properties" :key="p" class="mt-2">
                    <v-text-field  dense :label="prop.name" v-model="sku.properties[p].value"/>
                  </div>
              <strong>Details</strong>
              <v-divider class="mb-6"/>
                <v-select 
                  :items="units" 
                  v-model="sku.unit"
                  dense 
                  label="Unit"
                  outlined
                /> 
                <v-text-field
                  dense 
                   v-model="sku.cost"
                  type="number"
                  label="Cost"
                  outlined
                />  
                <v-text-field
                  dense 
                   v-model="sku.selling_price"
                   type="number"
                  label="Selling Price"
                  outlined
                />  
                <v-text-field
                v-if="Track(data.track)"
                 type="number"
                 outlined
                  dense 
                    v-model="sku.stock"
                  label="Avialable Stock"
                />
                <v-select  
                outlined
                 v-model="sku.status"
                  :items="product_statuses"
                  dense 
                  label="Availabilty"
                />             
          </v-card-text>
          <v-card-actions>
              <v-spacer/>
              <v-btn elevation="0"  @click="emitToParent('close')" tile>
                 Cancel
              </v-btn>
              <v-divider vertical class="ma-1"/>
              <v-btn elevation="0" color="success" @click="validate()" tile :disabled="disabled">
                  {{state=='new'?'ADD':'SAVE'}} 
              </v-btn>
              <v-spacer/>
          </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
      state: {
          type: String,
          default: 'new'
      },
      item: {
          type: Object,
          default: ()=>{}
      },
      data: {
          type: Object,
          default: ()=>{}
      },
  },
  data () {
      return {
        valid: true,
        disabled: false,
        units:[],
        sku:{},
        product_statuses:[]
      }
    },
  watch: {
    show(v){
      if(v){
        this.units = this.GET_SYSVARS('units')
        this.product_statuses = this.GET_SYSVARS('product_status')
        console.log(this.data)
        if(this.state == 'new') {
          this.sku.properties = this.data.properties
        } else {
          this.sku = this.item
        }
      } else {
        this.sku.properties = []
        this.sku = {}
        this.disabled = false
        console.log("close", this.sku)
      }
    }
  },
  computed:{
    
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    validate(){
      this.sku.selling_price = this.$IsNum(this.sku.selling_price)
      this.sku.cost = this.$IsNum(this.sku.cost)
      this.sku.stock = this.$IsNum(this.sku.stock)
      this.sku.product_id=this.$IsNum(this.data.id)

      this.disabled = true
      console.log(this.sku)
      if(this.state == 'new') {
           this.addItem()
      } else {
         this.saveItem()
      }
     
    },
    saveItem(){
    let params = {
            table: "product_items", 
            type:"newdata",
            query:`update product_items set stock=${this.sku.stock}, modified_on=NOW(), status='${this.sku.status}', 
            cost=${this.sku.cost}, selling_price=${this.sku.selling_price}, 
            properties='${JSON.stringify(this.sku.properties)}'::jsonb,
            unit='${this.sku.unit}' where id=${this.item.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          this.disabled = false
          this.emitToParent('close')
        }).catch(e => {
          console.log(e.data)
        })

    },

    addItem(){
      var userID = this.$IsNum(this.$session.get('userID'))
    let params = {
            table: "product_items", 
            type:"newdata",
            query:`INSERT INTO product_items(product_id, stock, added_dt, modified_on, status, cost, selling_price, properties, added_by, unit)
	VALUES (${this.sku.product_id}, ${this.sku.stock}, NOW(), NOW(), '${this.sku.status}', ${this.sku.cost}, ${this.sku.selling_price},'${JSON.stringify(this.sku.properties)}'::jsonb, ${userID}, '${this.sku.unit}')`
        }
        console.log(params)
      this.$http.post("new_data", params).then(response => {
        console.log(response)
        this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        this.disabled = false
        this.emitToParent('close')
      }).catch(e => {
        console.log(e.data)
      })

    }
  }
}
</script>
